import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import shipingService from "../services/shiping-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from "moment";
const tablePropsInit = {
  columns: [
    { key: "fac_name", title: "Facility Name" },
    { key: "createdAt", title: "Date" },
    { key: "fac_code", title: "DCode" },
    { key: "fac_id", title: "Facility ID" },
    { key: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const PublishList = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState("hidden");
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const CustomCell = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3">
          <a href={rowData.file_url} download="packingSlip.PDF">
            Download
          </a>
        </span>
      </div>
    );
  };
  const CustomCel2 = ({ rowData }) => {
    return <div>{moment(rowData.createdAt).format("YYYY-MM-DD")}</div>;
  };
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      try {
        let resp = await shipingService.getPublishList();
        resp.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        setLoading(false);
        if(resp.length>0){
          setShowList("show");  
          dispatch(updateData(resp));
        }else{
          const { hide } = cogoToast.error(
            "No Records Found",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
        
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error getting Publish List. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
        setShowList("hidden");
      }
    }
  };
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">PUBLISH LIST</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 -top-1 bottom-3"
              ></img>
            </span>
          </div>
        </div>
        <div className={`p-2 text-xs facPublishList overflow-x-auto gridList ${showList}`}>
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                    case "createdAt":
                      return <CustomCel2 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(PublishList)
);
